export enum MutationList {
    SET_MODAL_TYPE = 'SET_MODAL_TYPE',
    SET_MODAL_MESSAGE = 'SET_MODAL_MESSAGE',
    SET_MODAL_FOOTER_MESSAGE = 'SET_MODAL_FOOTER_MESSAGE',
    SET_MODAL_HEADER_MESSAGE = 'SET_MODAL_HEADER_MESSAGE',
    SET_MODAL_VISIBILITY_TRUE = 'SET_MODAL_VISIBILITY_TRUE',
    SET_MODAL_VISIBILITY_FALSE = 'SET_MODAL_VISIBILITY_FALSE',
    SET_AUTH_MODAL_VISIBILITY_TRUE = 'SET_AUTH_MODAL_VISIBILITY_TRUE',
    SET_AUTH_MODAL_VISIBILITY_FALSE = 'SET_AUTH_MODAL_VISIBILITY_FALSE',
    SET_SEARCH_MODAL_VISIBILITY_TRUE = 'SET_SEARCH_MODAL_VISIBILITY_TRUE',
    SET_SEARCH_MODAL_VISIBILITY_FALSE = 'SET_SEARCH_MODAL_VISIBILITY_FALSE',
    SELECT_LOADING_MODAL = 'SELECT_LOADING_MODAL',
    SELECT_MESSAGING_MODAL = 'SELECT_MESSAGING_MODAL',
    SET_SMALL_MODAL_MESSAGE_VISIBLE_TRUE = 'SET_SMALL_MODAL_MESSAGE_VISIBLE_TRUE',
    SET_SMALL_MODAL_MESSAGE_VISIBLE_FALSE = 'SET_SMALL_MODAL_MESSAGE_VISIBLE_FALSE',
    SET_SMALL_MODAL_MESSAGE_TITLE = 'SET_SMALL_MODAL_MESSAGE_TITLE',
    SET_SMALL_MODAL_MESSAGE_MESSAGE = 'SET_SMALL_MODAL_MESSAGE_MESSAGE',
    SELECT_SMALL_MODAL = 'SELECT_SMALL_MODAL'
}